import { FC } from 'react';
import { Alert } from '@mantine/core';
import { useSettings } from 'hooks/useSettings';
import { formatEventDateRange } from 'utils/dateUtils';

const InfoBanner: FC = () => {
    const { settings } = useSettings();

    const eventTime =
        settings?.startDate && settings?.endDate ? formatEventDateRange(settings.startDate, settings.endDate) : '';

    return (
        <Alert title="Lanit tulossa taas!">
            <div>
                Seuraavat lanit järjestetään {eventTime}. Tervetuloa!
            </div>
        </Alert>
    );
};

export default InfoBanner;
